// extracted by mini-css-extract-plugin
module.exports = {"Content":"layout_Content__2Zyeo"};